/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardViewDataModal_category = {
    readonly categories: ReadonlyArray<{
        readonly spoke: string;
        readonly spokeAcc: string;
        readonly email: string;
        readonly cellNumber: string;
        readonly isNull: boolean;
        readonly name: string;
        readonly key: string;
        readonly yesterdaysSalesToDate: number;
        readonly currentMonthToDate: number;
        readonly lastMonth: number;
        readonly lastMonthMonthToDate: number;
    }>;
    readonly totalRollup: {
        readonly spoke: string;
        readonly spokeAcc: string;
        readonly email: string;
        readonly cellNumber: string;
        readonly isNull: boolean;
        readonly name: string;
        readonly key: string;
        readonly yesterdaysSalesToDate: number;
        readonly currentMonthToDate: number;
        readonly lastMonth: number;
        readonly lastMonthMonthToDate: number;
    };
    readonly " $refType": "DashboardViewDataModal_category";
};
export type DashboardViewDataModal_category$data = DashboardViewDataModal_category;
export type DashboardViewDataModal_category$key = {
    readonly " $data"?: DashboardViewDataModal_category$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardViewDataModal_category">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spoke",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spokeAcc",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cellNumber",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isNull",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "yesterdaysSalesToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentMonthToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonth",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonthMonthToDate",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardViewDataModal_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailedSalesReportSales",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailedSalesReportSales",
      "kind": "LinkedField",
      "name": "totalRollup",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "DetailedSalesReportCategory",
  "abstractKey": null
};
})();
(node as any).hash = 'b112fec177b752a6cc396ff8e43444db';
export default node;
